import { render, staticRenderFns } from "./ProofreadingSelectType.vue?vue&type=template&id=03e87c12&scoped=true"
import script from "./ProofreadingSelectType.vue?vue&type=script&lang=ts"
export * from "./ProofreadingSelectType.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingSelectType.vue?vue&type=style&index=0&id=03e87c12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e87c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e87c12')) {
      api.createRecord('03e87c12', component.options)
    } else {
      api.reload('03e87c12', component.options)
    }
    module.hot.accept("./ProofreadingSelectType.vue?vue&type=template&id=03e87c12&scoped=true", function () {
      api.rerender('03e87c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/ProofreadingSelectType.vue"
export default component.exports